(function (){
    'use strict';

    angular
        .module('admin', [
            'ui.router',
            'ui.bootstrap',
            'ngDialog',
            'ui.select',
            'ngSanitize'
        ]);
})();